export default "__VITE_ASSET__Dt5i1Lh7__"